import { Col, Container, Row } from "reactstrap";
import Chip from "src/components/Common/UI/Chips/Chip";
import PhoneLines from "./PhoneLine/PhoneLines";
import LinesAndNodesHeader from "./LinesAndNodesHeaders";



const PhoneLineConfiguration = () =>{
  
    const chipHeaders = [""];
    const chipItems: React.ReactNode[] = [
      <PhoneLines />,
      
      
    ];
  
    return (
      <div className="page-content">
        <LinesAndNodesHeader />
  
        <Container fluid>
          <Row>
            <Col xs={12}>
              {<Chip
                tabNavHeaderItems={chipHeaders}
                tabContentItems={chipItems}
                hasStatusCircle={false}
              />}
            </Col>
          </Row>
        </Container>
  
  
      </div>
    );
}

export default PhoneLineConfiguration